// extracted by mini-css-extract-plugin
module.exports = {"root":"Card__root","clickable":"Card__clickable","card":"Card__card","card_hover":"Card__card_hover","back":"Card__back","front":"Card__front"};